// import Vue from 'vue';
import { createApp } from 'vue';
import App from './components/App.vue';

import appConfig from './models/Config';

const baseurl = location.pathname.replace(/\/[^\/]+$/, '/');

const params = new URLSearchParams(location.search);
params.forEach( (value, key) => {
	appConfig[key] = value;
});

const app = createApp(App, {
	baseurl,
	config: appConfig
});

app.mount('#app');
